import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Teamimage from './Images/Team.svg'
import facebook from './Images/facebook.png'
import insta from './Images/insta.png'
import linkdin from './Images/linkdin.svg'
import Pooja from '../../TeamImages/Pooja_Tosniwal.jpg'
import Pratit from '../../TeamImages/Pratit_Vijayvergia.png'
import ArvindBatra from '../../TeamImages/Arvind_Batra.jpg'
import Vipan_Bahl from '../../TeamImages/Vipan bahl.jpg'

const BoardofDirectors = () => {
  const [dynamicLeaders, setDynamicLeaders] = useState<any[]>([]);

  useEffect(() => {
    const fetchLeaders = async () => {
      try {
        const res = await axios.get('https://rmbbackend.rmbjaipur.com/auth/allusersinfo');
        const list = Array.isArray(res.data) ? res.data : (res.data.data || []);
        
        // Filter active leadership team members EXCEPT Coordinators
        const leaders = list.filter((u: any) => {
          if (u.delete === 1) return false;
          const subRole = (u.sub_role || '').toLowerCase();
          const designation = (u.designation || '').toLowerCase();
          const role = (u.role || '').toLowerCase();

          // EXCLUDE Coordinators from Leadership Page
          if (subRole.includes('coordinator') || designation.includes('coordinator') || role.includes('coordinator')) {
            return false;
          }

          return (
            (u.sub_role && u.sub_role.trim() !== '' && u.sub_role.trim() !== 'N/A') ||
            (u.role && u.role.toLowerCase() !== 'member' && u.role.toLowerCase() !== 'super-admin') ||
            designation.includes('chairman') ||
            designation.includes('secretary') ||
            designation.includes('treasurer') ||
            designation.includes('president') ||
            designation.includes('director')
          );
        });

        setDynamicLeaders(leaders);
      } catch (err) {
        console.error('Error fetching dynamic leadership team:', err);
      }
    };
    fetchLeaders();
  }, []);

  const defaultArray = [
    {
      name: 'Siddharth Makharia',
      position: 'Chairman',
      organization: 'Rajgharana Jewellers',
      Description: 'Gems & Jewellery • RMB Jaipur Leadership Team Chairman',
      Profile_Picture: `${ArvindBatra}`,
      Facebook: '#',
      Linkedin: '#'
    },
    {
      name: 'Gaurav Mathur',
      position: 'Vice Chairman',
      organization: 'Jorix Technology',
      Description: 'Digital Marketing Services • RMB Jaipur Leadership Team Vice Chairman',
      Profile_Picture: `${Vipan_Bahl}`,
      Facebook: '#',
      Linkedin: '#'
    },
    {
      name: 'ashish@aadviktech.com',
      position: 'Secretary',
      organization: 'Aadvik Tech Services',
      Description: 'Technology & Software • RMB Jaipur Leadership Team Secretary',
      Profile_Picture: `${Pooja}`,
      Facebook: '#',
      Linkedin: '#'
    },
    {
      name: 'Dr. Megha Sharma',
      position: 'Treasurer',
      organization: 'Amrit Kalp',
      Description: 'Physiotherapist & Wellness • RMB Jaipur Leadership Team Treasurer',
      Profile_Picture: `${Pratit}`,
      Facebook: '#',
      Linkedin: '#'
    }
  ];

  // Combine dynamic leaders with fallback defaults
  const displayLeaders = dynamicLeaders.length > 0 ? dynamicLeaders.map(u => ({
    name: u.name,
    position: u.sub_role || u.role || u.designation || 'Leader',
    organization: u.company_name || 'RMB Jaipur',
    Description: `${u.designation || u.company_name || 'Mapped Leadership Member'} • RMB Jaipur Active Leader`,
    Profile_Picture: u.profile 
      ? (u.profile.startsWith('http') ? u.profile : `https://rmbbackend.rmbjaipur.com/${u.profile.replace(/\\/g, '/')}`)
      : 'https://via.placeholder.com/200?text=Leader',
    Facebook: u.social || '#',
    Linkedin: u.social || '#'
  })) : defaultArray;
    return (
        <div>
          <div className="bg-[#1E2A3A] py-14 px-[8%] ">
            <div className="flex flex-wrap w-[100%] justify-between ">
              <div className=" sm:w-[50%]">
                <span className="text-[39px] leading-10	font-bold	text-[#F1F4F9] ml-2">
                Leadership 
                </span>
                <span className="text-[#FDBC12] text-[39px] leading-10	font-bold pl-2	">
                Team
                </span>
              </div>
            </div>
            <div>
            <div>
          <div className="w-[100%] flex flex-wrap justify-between mt-[70px] gap-y-10 ">
          {displayLeaders.map((data, index) =>(
            <div className=" flex flex-wrap lg:w-[48%] w-[100%] gap-4">
            <div className=" w-[200px] h-[200px] p-3 border-2 border-[#FDBC12] rounded-full flex justify-center items-center">
                <img className=" w-full h-full rounded-full object-cover" src={data.Profile_Picture} alt="" />
            </div>
            <div className=" sm:w-[60%] w-[100%] flex flex-col justify-center sm:mt-0 mt-4">
            <h5 className="sm:text-[24px] text-[18px] font-semibol text-[#F5F5F5]">{data.name}</h5>
            <p className="text-[14px] font-semibol text-[#D7D3D2]">{data.position}</p>
            <div className="w-[171px] h-[2px] bg-[#FDBC12] mt-5"></div>
            <p className="text-[12px] text-[#94A2B8] mt-5 min-h-[95px]">{data.Description}</p>
            <div className="flex items-center mt-3">   <img className="w-[24px] h-[24px] " src={facebook} alt="" />
            <img className="w-[24px] h-[24px] ml-4" src={insta} alt="" onClick={()=>{
              window.location.href=`${data.Facebook}`
            }}/>
            <img className="w-[24px] h-[24px]  ml-4" src={linkdin} alt="" onClick={()=>{
              window.location.href=`${data.Linkedin}`
            }} />
            <button className="bg-[#FDBC12] w-[150px] py-2 rounded text-[#101729] text-[12px] font-normal ml-4">
            Connect With Me
            </button>

            </div>
            </div>
           
         
          </div>
          ))}
          </div>
        </div>
            </div>
          </div>
        </div>
      );
}

export default BoardofDirectors